import { useEffect } from "react";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useRouter } from "../useRouter";
import { applyCheckPromotionCode, checkPromotionTrial } from "src/service/pay";
import {
  hasBillAtom,
  hasSiteAtom,
  navStepAtom,
  productKeyAtom,
} from "src/atoms";
import { useRecoilState } from "recoil";
import { useGetMyServiceList } from "../api/product/useGetMyServiceList";
import { notifyError } from "src/components/Common/Toast";
import { useGetPayUnregisterBill } from "../api/bill/useGetPayUnregisterBill";
import { useGetPromotionUnregisterBill } from "../api/bill/useGetPromotionUnregisterBill";

// 구매한 사이트가 있는지 확인하는 Hook
export function useCheckHasBill() {
  const route = useRouter();
  const { serviceList } = useGetMyServiceList({});
  const { unregisterPayList } = useGetPayUnregisterBill({});
  const { unregisterPromotionList } = useGetPromotionUnregisterBill({});
  const [hasBill, setHasBill] = useRecoilState(hasBillAtom);
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  const [hasSite, setHasSite] = useRecoilState(hasSiteAtom);
  const [productName, setProductName] = useRecoilState(productKeyAtom);
  useEffect(() => {
    const init = async () => {
      try {
        // 전역상태 확인
        // setNavStep(0);
        setHasSite(false);
        setHasBill(false);
        if (
          serviceList?.length === 0 &&
          unregisterPayList &&
          unregisterPromotionList
        ) {
          try {
            // 사이트를 생성할 것이 남아 있다면
            // const unregisterPay = await getServiceUnregisterBill({
            //   billType: "PAY",
            //   product: getProductFromSessionStorage(),
            // });

            // const unregisterPromotion = await getServiceUnregisterBill({
            //   billType: "PROMOTION",
            //   product: getProductFromSessionStorage(),
            // });
            if (unregisterPayList.length > 0) {
              setHasBill(true);
            } else if (unregisterPromotionList.length > 0) {
              setNavStep(3);
              setHasBill(true);
            } else {
              let makeType = "";
              const result = await applyCheckPromotionCode({
                product: getProductFromSessionStorage(),
              });
              if (result) {
                // 백엔드가 타입 유니온 밖 값(C_APPROVED)을 반환할 수 있어 런타임 비교를 유지
                if ((result as string) === "C_APPROVED") {
                  // window.location.href = `${process.env.PUBLIC_URL}/${lang}/site/promotion`;
                  route.goSitePromotion({});
                } else {
                  makeType = result;
                }
              } else {
                // 체험(trial) 확인은 반환 형태가 달라 변수 분리
                const trialResult = await checkPromotionTrial({
                  product: getProductFromSessionStorage(),
                });

                if (trialResult === "T_APPROVED") {
                  setHasBill(true);
                }
              }
            }
          } catch (error) {
            console.log("error", error);
            route.goSiteType();
          }
        } else {
          setHasSite(true);
          setHasBill(true);
        }
      } catch (error: any) {
        if (error?.errorCode && error?.errorMessage) {
          notifyError(error.errorMessage);
        }
      }
    };

    if (unregisterPayList && unregisterPromotionList) init();
  }, [productName, unregisterPayList, unregisterPromotionList]);
}
